import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Sparkles, ArrowLeft, ExternalLink, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import AdSlot from "@/components/AdSlot";

export default function Suggestions() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { (async () => {
    try { const r = await api.get("/suggestions"); setItems(r.data.suggestions || []); }
    finally { setLoading(false); }
  })(); }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F3F4F6]">
      <header className="px-6 py-4 border-b border-[#1E1E1E] flex items-center gap-3 sticky top-0 bg-[#0A0A0A]/90 backdrop-blur z-10">
        <Link to="/app" data-testid="suggestions-back-link"><Button variant="ghost" size="icon" className="text-[#9CA3AF] hover:bg-[#1E1E1E]"><ArrowLeft className="h-4 w-4"/></Button></Link>
        <h1 className="font-heading text-xl font-bold flex items-center gap-2"><Sparkles className="h-5 w-5 text-[#3B82F6]"/> Suggestions for you</h1>
        <span className="ml-auto text-[10px] uppercase tracking-wider text-[#6B7280] hidden sm:inline">Sponsored · AI-curated</span>
      </header>

      <div className="px-6 py-8 max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-[1fr_280px] gap-6">
        <main>
          {loading ? (
            <div className="flex items-center justify-center py-20 text-[#6B7280]"><Loader2 className="h-5 w-5 animate-spin mr-2"/>Curating with GPT-5.2…</div>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {items.map(s => (
                <article key={s.id} data-testid={`suggestion-${s.id}`} className="rounded-2xl bg-[#121212] border border-[#1E1E1E] overflow-hidden hover:border-[#3B82F6]/40 transition-all">
                  <div className="h-36 w-full bg-[#1E1E1E] overflow-hidden">
                    <img src={s.image_url} alt="" className="h-full w-full object-cover" onError={(e) => e.currentTarget.src = "https://images.pexels.com/photos/7641028/pexels-photo-7641028.jpeg"}/>
                  </div>
                  <div className="p-4 space-y-2">
                    <div className="text-[10px] uppercase tracking-wider text-[#3B82F6]">{s.category}</div>
                    <h3 className="font-heading font-semibold text-base leading-tight">{s.name}</h3>
                    <p className="text-xs text-[#9CA3AF] line-clamp-3">{s.reason}</p>
                    <div className="flex items-center justify-between pt-2">
                      <span className="text-sm font-semibold">${(s.price_cents/100).toFixed(2)}</span>
                      <a href={s.affiliate_url} target="_blank" rel="noopener noreferrer external" data-testid={`affiliate-${s.id}`} className="inline-flex items-center gap-1 text-xs px-3 py-1.5 rounded-full bg-[#2563EB] hover:bg-[#1D4ED8] text-white transition-all">
                        Visit <ExternalLink className="h-3 w-3"/>
                      </a>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          )}
          <p className="text-[10px] text-[#6B7280] mt-6">Disclosure: Suggestion links are affiliate links; NoteLosh may earn a commission.</p>
        </main>
        <aside className="space-y-4">
          <AdSlot slot="sugg-side-1"/>
          <AdSlot slot="sugg-side-2"/>
        </aside>
      </div>
    </div>
  );
}
